import DynamikOverview from '../../dynamikModul/Modules/Pages/overview'
import React from 'react'
import {
    ResponseOverview,
    ResponseDelete,
    ResponseDetail,
    ResponseBuisnessKeys
} from './API/response/Type/customizer'
import DynamikDeleted from '../../dynamikModul/Modules/Pages/deleted'
import DynamikDetail from '../../dynamikModul/Modules/Pages/detail'
import DynamikNew from '../../dynamikModul/Modules/Pages/new'
import table from './configuration/table'
import { destination, link } from './helper/const'
import SearchConfig from './configuration/SearchConfig'
import CardJSX from './configuration/card'
import Forms from './configuration/Form'

export const SROPagesConfig = (value: any) => {
    return [
        {
            path: '/sro/overview/:page',
            elements: (
                <DynamikOverview
                    value={value}
                    table={table}
                    destination={destination}
                    state={'sro'}
                    SearchConfig={SearchConfig(destination)}
                    CardsConfiguration={CardJSX(link, destination)}
                    response={ResponseOverview}
                    nonewButton={true}
                    buttonText={'s.r.o '}
                />
            ),
            roles: ['superadmin', 'admin']
        },
        {
            path: '/sro/Delete/:page/:deleteID',
            elements: (
                <DynamikDeleted
                    value={value}
                    reponse={ResponseDelete}
                    namespace={destination}
                />
            ),
            roles: ['superadmin', 'admin']
        },
        {
            path: '/sro/new/new',
            elements: (
                <DynamikNew
                    value={value}
                    forms={Forms}
                    addedForm={ResponseBuisnessKeys}
                    namespace={'/' + destination + '/overview/1'}
                    saveRoute={'company/sro/0/'}
                />
            ),
            roles: ['superadmin', 'admin']
        },
        {
            path: '/sro/new/:page',
            elements: (
                <DynamikNew
                    value={value}
                    forms={Forms}
                    addedForm={ResponseBuisnessKeys}
                    namespace={'/' + destination + '/overview/1'}
                    saveRoute={'company/sro/0/'}
                />
            ),
            roles: ['superadmin', 'admin']
        },
        {
            path: '/sro/Detail/:id',
            elements: (
                <DynamikDetail
                    value={value}
                    forms={Forms}
                    addedForm={ResponseBuisnessKeys}
                    response={ResponseDetail}
                    saveRoute={'company/sro/'}
                />
            ),
            roles: ['superadmin', 'admin']
        }
    ]
}

export const SROMenuConfig = (value: any) => {
    return [
        {
            name: 's.r.o',
            route: '/sro/overview/1',
            icon: 'cases',
            roles: ['superadmin', 'admin']
        }
    ]
}
export const SRODasboard = () => [
    {
        title: 's.r.o',
        href: '/sro/overview/1',
        undertitle: 'Backoffice',
        icon: 'cases',
        text: 's.r.o',
        roles: ['superadmin', 'admin']
    }
]
